import React from "react";
import { Modal, Row, Col, Table } from "react-bootstrap";

export default function EditPreviewModal({ show, onHide }) {
  return (
    <Modal show={show} onHide={onHide} size="lg" centered>
      <Modal.Body className="p-4 invoice-modal">

        {/* HEADER */}
        <div className="d-flex justify-content-between align-items-start mb-3">
          <div>
            <h4 className="fw-bold text-danger">SmartHR</h4>
            <p className="mb-0 small">
              3099 Kennedy Court Framingham, MA 01702
            </p>
          </div>

          <div className="text-end">
            <h6>
              Invoice No <span className="text-warning">#INV0001</span>
            </h6>
            <p className="mb-1 small">Created Date : Sep 24, 2023</p>
            <p className="small">Due Date : Sep 30, 2023</p>
          </div>
        </div>

        <hr />

        {/* FROM / TO */}
        <Row className="mb-3">
          <Col md={4}>
            <h6>From</h6>
            <strong>Thomas Lawler</strong>
            <p className="mb-1 small">2077 Chicago Avenue</p>
            <p className="mb-1 small">Email : [email protected]</p>
            <p className="small">Phone : +1 987 654 3210</p>
          </Col>

          <Col md={4}>
            <h6>To</h6>
            <strong>Sara Inc.,</strong>
            <p className="mb-1 small">3103 Trainer Avenue</p>
            <p className="mb-1 small">Email : [email protected]</p>
            <p className="small">Phone : +1 987 471 6589</p>
          </Col>

          <Col md={4} className="text-md-end">
            <h6>Payment Status</h6>
            <span className="badge bg-danger">Due in 10 Days</span>

            <div className="mt-2">
              <img
                src="https://api.qrserver.com/v1/create-qr-code/?size=80x80&data=Invoice"
                alt="qr"
              />
            </div>
          </Col>
        </Row>

        <hr />

        {/* INVOICE FOR */}
        <p className="mb-3">
          <strong>Invoice For :</strong> Design & development of Website
        </p>

        {/* TABLE */}
        <Table bordered responsive className="mb-3">
          <thead className="table-light">
            <tr>
              <th>Job Description</th>
              <th>Qty</th>
              <th>Cost</th>
              <th>Discount</th>
              <th>Total</th>
            </tr>
          </thead>

          <tbody>
            <tr>
              <td>UX Strategy</td>
              <td>1</td>
              <td>$500</td>
              <td>$100</td>
              <td>$500</td>
            </tr>
            <tr>
              <td>Design System</td>
              <td>1</td>
              <td>$5000</td>
              <td>$100</td>
              <td>$5000</td>
            </tr>
            <tr>
              <td>Brand Guidelines</td>
              <td>1</td>
              <td>$5000</td>
              <td>$100</td>
              <td>$5000</td>
            </tr>
            <tr>
              <td>Social Media Template</td>
              <td>1</td>
              <td>$5000</td>
              <td>$100</td>
              <td>$5000</td>
            </tr>
          </tbody>
        </Table>

        {/* TOTALS */}
        <Row className="mb-3">
          <Col md={6}>
            <h6>Terms and Conditions</h6>
            <p className="small">
              Please pay within 15 days from the date of invoice, overdue
              interest @14% will be charged.
            </p>

            <h6>Notes</h6>
            <p className="small">
              Please quote invoice number when remitting funds.
            </p>
          </Col>

          <Col md={6}>
            <div className="d-flex justify-content-between">
              <span>Sub Total</span>
              <span>$5500</span>
            </div>

            <div className="d-flex justify-content-between">
              <span>Discount(0%)</span>
              <span>$400</span>
            </div>

            <div className="d-flex justify-content-between">
              <span>VAT(5%)</span>
              <span>$54</span>
            </div>

            <hr />

            <div className="d-flex justify-content-between fw-bold">
              <span>Total Amount</span>
              <span>$5775</span>
            </div>

            <p className="small mt-1">
              Amount in Words : Dollar Five thousand Seven Seventy Five
            </p>
          </Col>
        </Row>

        {/* SIGNATURE */}
        <div className="text-end mb-3">
          <p style={{ fontFamily: "cursive", fontSize: "22px" }}>
            Signature
          </p>
          <p className="mb-0">Ted M. Davis</p>
          <small>Assistant Manager</small>
        </div>

        <hr />

        {/* FOOTER */}
        <div className="text-center">
          <h5 className="text-danger">SmartHR</h5>
          <p className="small">
            Payment Made Via bank transfer / Cheque in the name of Thomas
            Lawler
          </p>
        </div>
      </Modal.Body>
      <style>
          {
              `
              .invoice-modal {
  font-size: 14px;
}

.invoice-modal h6 {
  font-weight: 600;
}

.invoice-modal .table th {
  background: #f5f5f5;
}

.badge {
  padding: 6px 10px;
  font-size: 12px;
}

@media (max-width: 768px) {
  .invoice-modal {
    font-size: 12px;
  }

  .invoice-modal h4 {
    font-size: 16px;
  }
}` 
          }
      </style>
    </Modal>
  );
}